<template>
  <div>
    <router-view />
    <main-header-info :navInfoItems="schema.navInfoItems" />
    <pat-sign-up
      :schemaForm="schema.schemaForm"
      :modelForm="model"
      :save="handleSignUp"
      :checkboxTerms="checkboxTerms"
      :handleEventsbox="handleEventsbox"
      :status="status"
    />
    <v-snack-bar :snackbar="snackbar" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderInfo from '@/components/includes/MainHeaderInfo.vue';
import PatSignUp from '@/components/enter/PatSignUp.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'PatSignUpPage',
  components: {
    MainHeaderInfo,
    PatSignUp,
    VSnackBar,
  },
  data() {
    return {
      checkboxTerms: false,
      model: {},
    };
  },
  mounted() {
    this.loadSchema();
  },
  computed: {
    ...mapGetters('patSignUpPage', ['schema']),
    ...mapGetters('authPat', ['status', 'msgError']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('patSignUpPage', ['loadSchema']),
    ...mapActions('notifications', ['triggerSnackbar']),

    handleEventsbox(val) {
      this.valCheck = val;
    },

    async handleSignUp() {
      try {
        const { group1 } = this.model;
        const model = { ...group1 };

        if (this.valCheck !== undefined) {
          model.users_terms = this.valCheck === true ? 1 : 0;
        } else {
          model.users_terms = this.users_terms;
        }

        await this.$store.dispatch('authPat/signUp', model);

        if (this.status === 'success') {
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = this.schema.snackOk;

          this.$store.commit('auth/SET_STATUS', 'loaded');

          setTimeout(() => {
            this.snackbar.visible = false;
            this.$router.push({ name: 'patLogin' });
          }, 4000);

        } else if (this.status === 'error') {
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = this.msgError;

          this.$store.commit('auth/SET_STATUS', 'loaded');
        }

      } catch (error) {
        console.error("Error Firebase:", error.message);

        this.snackbar.visible = false;
        this.snackbar.visible = true;
        this.snackbar.content = error.message;

        this.$store.commit('auth/SET_STATUS', 'loaded');
      }
    }
  },
};
</script>
